import { UserConsent, noConsent } from "cookiesConsent/domain/consent"
import { VisitorIdentity } from "cookiesConsent/domain/VisitorIdentity"
import { SegmentCategoriesFactory } from "cookiesConsent/infrastructure/segment/SegmentCategories"
import { consentBus } from "cookiesConsent/infrastructure/segment/ConsentBus"
import { Tracking } from "cookiesConsent/domain/tracking"
import { SegmentTracking } from "cookiesConsent/infrastructure/segment/SegmentTracking"
import { visitorIdentityForThisPage } from "cookiesConsent/infrastructure/segment/visitorIdentityForThisPage"
import { latestConsent } from "cookiesConsent/features/getConsent/latestConsent"

export class VisitorIdentityActivation {
  private readonly tracking: Tracking
  private readonly identity: VisitorIdentity

  private startedWith: UserConsent | null = null

  constructor(tracking: Tracking, identity: VisitorIdentity) {
    this.tracking = tracking
    this.identity = identity
  }

  start = (consent: UserConsent): void => {
    if (this.startedWith) {
      this.ignore()
    } else {
      this.startedWith = consent
      latestConsent.publish(consent)
      consentBus.publish(new SegmentCategoriesFactory().fromConsent(consent))
      this.identity.confirm().then(this.tracking.start)
    }
  }

  startedConsent = (): UserConsent => this.startedWith ?? noConsent

  reset = (): void => {
    this.startedWith = null
  }

  requiresRestart = (consent: UserConsent): boolean => {
    if (!this.startedWith) {
      return false
    } else {
      return !new SegmentCategoriesFactory()
        .fromConsent(this.startedWith)
        .equals(new SegmentCategoriesFactory().fromConsent(consent))
    }
  }

  private ignore = (): void => {}
}

let activation: VisitorIdentityActivation | undefined

export const visitorIdentityActivation = (): VisitorIdentityActivation => {
  activation =
    activation ??
    new VisitorIdentityActivation(
      new SegmentTracking(),
      visitorIdentityForThisPage()
    )
  return activation
}
